const formatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 });

/** Format a numeric value for tooltip display — at most 2 decimal places, no float noise. */
export function formatTooltipValue(value: number): string {
    return formatter.format(value);
}
